import isEqual from 'lodash/isEqual';
import { createTier } from './tier';
import { TgvTier } from './tiergruppe.model';

export const EINGABE_HEADLINE_ID = 'tgv-eingabe-headline';

export const JURISTISCH_HINT_ID = 'tgv-juristisch-hint';

export const tierartTitleId = (cardId: string): string => `tierart-title-${cardId}`;

export const isUntouchedTier = (tier: TgvTier): boolean => isEqual(tier, createTier(tier.cardId));
